var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge-box"},[_c('span',{staticClass:"text"},[_vm._v("New")])])
}]

export { render, staticRenderFns }